<div class="footer-container" *ngIf="enterprise$ | async as enterprise">
  <div class="enterprise-contacts-container" *ngIf="enterprise.telefoneCentralAtendimento; else onlyImage">
    <div>
      <h6>Central de Atendimento</h6>
      <div class="email-text">{{ enterprise.emailCentralAtendimento }}</div>
      <div class="text-phone" [ngClass]="isWhitePhoneNumber ? 'text-light' : 'text-secondary'">
        <fa-icon [icon]="faPhoneAlt"></fa-icon>
        {{ enterprise.telefoneCentralAtendimento }}
      </div>
    </div>
    <div class="logo-ans-container">
      <img class="logo-img" [src]="enterprise.logoTransparenteUrl" />
      <img class="ans-img" [src]="enterprise.ansImg" />
    </div>
    <div class="logo-ans-container">
      <div class="policy-text">
        <a *ngIf="route_seguranca.startsWith('http')" [attr.href]="route_seguranca" target="_blank">
          Política de segurança da informação
        </a>
        <a *ngIf="!route_seguranca.startsWith('http')" [routerLink]="route_seguranca">
          Política de segurança da informação
        </a>
      </div>
      <div class="policy-text">
        <a *ngIf="route_privacidade.startsWith('http')" [attr.href]="route_privacidade" target="_blank">
          Política de privacidade
        </a>
        <a *ngIf="!route_privacidade.startsWith('http')" [routerLink]="route_privacidade">Política de privacidade</a>
      </div>
    </div>
  </div>

  <ng-template #onlyImage>
    <div class="d-flex justify-content-center">
      <img class="logo-img" [src]="enterprise.logoRodape" />
    </div>
  </ng-template>

  <div class="version-container">
    <small>Versão do app: {{ version }}</small>
  </div>
</div>
